export enum AuthorizationRequestEntityTypeEnum {
  Functionality = 1,
  Product = 2,
  PriceComponent = 3,
}
